import { render, staticRenderFns } from "./swiperCon.vue?vue&type=template&id=710daff4&scoped=true&"
import script from "./swiperCon.vue?vue&type=script&lang=js&"
export * from "./swiperCon.vue?vue&type=script&lang=js&"
import style0 from "./swiperCon.vue?vue&type=style&index=0&id=710daff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710daff4",
  null
  
)

export default component.exports